import { render, staticRenderFns } from "./TgPrivilegeBulkChangeDialog.vue?vue&type=template&id=58bf1f1e"
import script from "./TgPrivilegeBulkChangeDialog.vue?vue&type=script&lang=js"
export * from "./TgPrivilegeBulkChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports